export function changeUserAvatar(avatar) {
  return {
    type: 'CHANGE_AVATAR',
    avatar
  }
}
